import { hc } from "hono/client";
import type { AddressesType } from "@/api/routes/addresses";
import type { AdminType } from "@/api/routes/admins";
import type { AnalyticsType } from "@/api/routes/analytics";
import type { CartType } from "@/api/routes/cart";
import type { FavouriteType } from "@/api/routes/favourites";
import type { MenuType } from "@/api/routes/menu";
import type { NotificationType } from "@/api/routes/notifications";
import type { OrderType } from "@/api/routes/orders";
import type { PaymentType } from "@/api/routes/payments";
import type { PreferencesType } from "@/api/routes/preferences";
import type { UploadsType } from "@/api/routes/uploads";
import type { UserType } from "@/api/routes/users";

const baseUrl =
	process.env.BUN_PUBLIC_SERVER_URL || "http://localhost:3000/api/v1";

const client = {
	orders: hc<OrderType>(`${baseUrl}/orders`, {
		init: {
			credentials: "include",
		},
	}),
	users: hc<UserType>(`${baseUrl}/users`, {
		init: {
			credentials: "include",
		},
	}),
	addresses: hc<AddressesType>(`${baseUrl}/user/addresses`, {
		init: {
			credentials: "include",
		},
	}),
	menu: hc<MenuType>(`${baseUrl}/menu`, {
		init: {
			credentials: "include",
		},
	}),
	admins: hc<AdminType>(`${baseUrl}/admins`, {
		init: {
			credentials: "include",
		},
	}),
	notifications: hc<NotificationType>(`${baseUrl}/notifications`, {
		init: {
			credentials: "include",
		},
	}),
	favourites: hc<FavouriteType>(`${baseUrl}/favourites`, {
		init: {
			credentials: "include",
		},
	}),
	cart: hc<CartType>(`${baseUrl}/cart`, {
		init: {
			credentials: "include",
		},
	}),
	preferences: hc<PreferencesType>(`${baseUrl}/preferences`, {
		init: {
			credentials: "include",
		},
	}),
	analytics: hc<AnalyticsType>(`${baseUrl}/analytics`, {
		init: {
			credentials: "include",
		},
	}),
	uploads: hc<UploadsType>(`${baseUrl}/uploads`, {
		init: {
			credentials: "include",
		},
	}),
	payments: hc<PaymentType>(`${baseUrl}/payments`, {
		init: {
			credentials: "include",
		},
	}),
};

export default client;
